// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"_1u5PSJ6fQD82Zz-8Srs2CW","closeIcon":"_2kNTk99vj0o73USePaCrdC","item":"wz4TfQM7B_bSPxDi3ndnT","list":"_3lJdqvTO1h83IPpOYpl5KY"};